import { useTheme } from "@/hooks/useTheme";
import { Sun, Moon, CircleHalf } from "@phosphor-icons/react";

export function ThemeToggle({ className = "" }) {
  const { mode, cycle } = useTheme();
  const Icon = mode === "light" ? Sun : mode === "dark" ? Moon : CircleHalf;
  const label = mode === "light" ? "Clair" : mode === "dark" ? "Sombre" : "Auto (jour/nuit)";
  return (
    <button
      onClick={cycle}
      data-testid="theme-toggle"
      title={`Thème : ${label} — cliquez pour changer`}
      aria-label={`Thème : ${label}`}
      className={`inline-flex items-center justify-center h-9 w-9 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors ${className}`}
    >
      <Icon size={18} weight={mode === "light" ? "fill" : "regular"} />
    </button>
  );
}
